// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1fo5B","upload":"Small_upload__2VIyw","imageWrap":"Small_imageWrap__3Js3e","removeBtn":"Small_removeBtn__1_3A0"};